import { ActionTree, GetterTree, MutationTree } from 'vuex';
import HomeSmartApi from '@/plugins/HomeSmartApi';
import { UserLoginData } from '@/modules/backend/Dto/UserLoginData';
import { User } from '@/modules/backend/Entities/User';
import { Company } from '@/modules/backend/Entities/Company';
import { Resource } from '@/modules/backend/Entities/Resource';

interface State {
  IsLoaded: boolean;
  IsAuth: boolean;
  Info?: User;
}

export const state: State = {
  Info: undefined,
  IsAuth: false,
  IsLoaded: false
};

export const getters: GetterTree<State, unknown> = {
  IsAuth: (store) => store.IsAuth,
  Info: (store) => store.Info,
  CompanyById: (store: State) => (companyId: number): Company | undefined => {
    return store.Info?.getCompanies().find((company: Company) => (company.getId() === companyId));
  },
  IsAdmin: (store) => store.Info && store.Info.isAdmin(),
  Resources: (store) => {
    if (!store.Info) {
      return [];
    }

    return Array.from(store.Info
      .getProviders().flatMap((provider) => provider.getResources())
      .concat(store.Info.getCompanies().flatMap((company) => company.getResources()))
      .reduce((accum, resource) => (accum.set(resource.getId(), resource)), new Map<number, Resource>())
      .values());
  }
};

export const mutations: MutationTree<State> = {
  IsAuth: (store, payload: boolean) => (store.IsAuth = payload),
  Info: (store, payload) => (store.Info = payload),
  LogOut: (store) => {
    store.IsAuth = false;
    store.Info = undefined;
  }
};

export const actions: ActionTree<State, unknown> = {
  async LoadInfo({ commit }) {
    try {
      const info = await HomeSmartApi.Users.Info();

      commit('Info', info);
    } catch (e) {
      console.log('cannot read info');
    }
  },
  async Login({ commit, dispatch }, payload: UserLoginData) {
    await HomeSmartApi.Users.LogIn(payload);

    commit('IsAuth', true);
    dispatch('LoadInfo');

    return true;
  },
  async LogOut({ commit }) {
    const status = await HomeSmartApi.Users.LogOut();

    if (status) {
      commit('LogOut');
    }
  }
};

export const auth = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
